import { ConfirmationDialog } from 'legacy/lut/components/shared/Confirm/ConfirmationDialog'
import { FC } from 'react'

import { TRANSLATION_KEYS } from '../../../../translations'

import { QBR_DOCUMENT_SAVE_CONFIRM_IDENTIFIER } from './configs'

export const QbrDocumentSaveConfirm: FC = () => {
  return (
    <ConfirmationDialog
      translation
      identifier={QBR_DOCUMENT_SAVE_CONFIRM_IDENTIFIER}
      text={TRANSLATION_KEYS.saveConfirmDialog.saveSettingModalConfirm}
      submitText={TRANSLATION_KEYS.saveConfirmDialog.saveSettingModalButton}
      submitColor="success"
    />
  )
}
